import { render, staticRenderFns } from "./marketDetail.vue?vue&type=template&id=48c6edda&"
import script from "./marketDetail.vue?vue&type=script&lang=js&"
export * from "./marketDetail.vue?vue&type=script&lang=js&"
import style0 from "./marketDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports